import { render, staticRenderFns } from "./bg-white.vue?vue&type=template&id=3dd265b8&"
import script from "./bg-white.vue?vue&type=script&lang=js&"
export * from "./bg-white.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports